var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body promotion-info" }, [
    _c(
      "div",
      { staticClass: "row hpanel" },
      [
        _c("base-table", {
          attrs: {
            url: "PromotionResult/list",
            method: "post",
            columns: _vm.$options.promotionColumns,
            isSearchable: true,
            isSearchMultiple: true,
            malls: _vm.malls,
            paginationStorageKey: "promotionList"
          },
          on: { keyword: _vm.onHandleSearch },
          scopedSlots: _vm._u([
            {
              key: "orderDate",
              fn: function(props) {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatDate(props.rowData.orderDate)))
                  ])
                ]
              }
            },
            {
              key: "itemImageUrl",
              fn: function(props) {
                return [
                  _c("img", {
                    staticClass: "product-img",
                    attrs: {
                      src: _vm.prepareImgSrc(props.rowData.itemImageUrl)
                    }
                  })
                ]
              }
            },
            {
              key: "detail",
              fn: function(props) {
                return [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.replaceHTMLSellerInfo(props.rowData.detail)
                      )
                    }
                  })
                ]
              }
            },
            {
              key: "totalAmount",
              fn: function(props) {
                return [
                  _c(
                    "span",
                    {
                      class: {
                        "text-red": _vm.isMinus(props.rowData.totalAmount)
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.formatAmount(props.rowData.totalAmount))
                      )
                    ]
                  )
                ]
              }
            },
            {
              key: "mallCode",
              fn: function(props) {
                return [
                  _c("img", {
                    attrs: { src: _vm.prepareImgSrc(props.rowData.mall) }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-552452d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552452d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/promotion/PromotionInfo.vue
// module id = null
// module chunks = 